import { useState } from "react";
import api from "utils/api";
import { Modal } from "../../components/core/basic/RACModal";
import { Center, VStack } from "../../../styled-system/jsx";
import { TextField } from "../../components/fields/base/TextField";
import { css } from "../../../styled-system/css";
import { Button } from "../../components/core/basic/Button";

const createCustomApp = async (shopName: string, apiKey: string, apiSecretKey: string, accessToken: string) => {
  await api.post("/shopify/custom-app", {
    shop: shopName,
    api_key: apiKey,
    api_secret_key: apiSecretKey,
    access_token: accessToken,
  });
};

interface Props {
  is_visible?: boolean;
  onHide: () => void;
  oauthUrl?: string;
}

const ShopifySetup = (props: Props) => {
  const [shopName, setShopName] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [apiSecretKey, setApiSecretKey] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [success, setSuccess] = useState(false);

  const onSubmit = async () => {
    if (shopName === "") {
      return;
    }

    if (apiKey === "" || apiSecretKey === "" || accessToken === "") {
      return;
    }

    await createCustomApp(shopName, apiKey, apiSecretKey, accessToken);
    setSuccess(true);
  };

  return (
    <Modal
      isOpen={props.is_visible}
      title={"Connect With Shopify"}
      onOpenChange={(isOpen) => !isOpen && props.onHide()}
    >
      {success && <Center>Shopify store connected successfully!</Center>}
      {!success && (
        <VStack alignItems={"stretch"} paddingX={"xlarge"}>
          <h4 className={css({ margin: 0 })}>Enter the custom API credentials for your Shopify store.</h4>
          <TextField
            label={"Store name"}
            placeholder="my-shop"
            endIcon={".myshopify.com"}
            value={shopName}
            onChange={setShopName}
          />
          <TextField label={"API Key"} value={apiKey} onChange={setApiKey} />
          <TextField label={"API Secret Key"} value={apiSecretKey} onChange={setApiSecretKey} />
          <TextField label={"Access Token"} value={accessToken} onChange={setAccessToken} />

          <Center>
            <Button onPress={() => void onSubmit()}>Connect To Shopify </Button>
          </Center>
        </VStack>
      )}
    </Modal>
  );
};

export default ShopifySetup;
